import { RxStompConfig } from '@stomp/rx-stomp';
import { environment } from '/app/environments/environment';

const token = localStorage.getItem('access_token');  

export const rxStompConfig: RxStompConfig = {
  // Which server?
  brokerURL: `${environment.websocketHost}/ws-alarm`,

  // Headers (typical keys: login, passcode, host)
  connectHeaders: {
    authorization: token ? `Bearer ${token}` : ''
  },

  // Heartbeats (ms). Set 0 to disable.
  heartbeatIncoming: 0,
  heartbeatOutgoing: 20000,

  // Reconnect delay (ms). Set 0 to disable.
  reconnectDelay: 5000,

  // Console diagnostics (avoid in production)
  debug: (msg: string): void => {
    console.log(new Date(), msg);
  },
};